import React, { memo, useCallback, useMemo } from "react";
import colors from "app/colors";

import { ClockArrowPlusIcon } from "modules/icons";
import {
  InternalAdminDistributionGroupFragment,
  InternalAdminGrantHistoricalAccessMutation,
  InternalAdminGrantHistoricalAccessMutationVariables,
} from "gql/graphql";
import CircularIconButton from "modules/_shared/buttons/circular-icon-button";
import { useMutation } from "@apollo/client";
import SyncoTooltip from "modules/_shared/synco-tooltip";
import { Spinner } from "@chakra-ui/react";
import INTERNAL_ADMIN_GRANT_HISTORICAL_ACCESS_MUTATION from "../_networking/internal-admin-grant-historical-access";

interface IProps {
  distributionGroup?: InternalAdminDistributionGroupFragment;
  userId: string;
}

const InternalAdminGrantHistoricalAccessButton = ({
  distributionGroup,
  userId,
}: IProps) => {
  const [internalAdminGrantHistoricalAccessMutationAPI, { loading }] =
    useMutation<
      InternalAdminGrantHistoricalAccessMutation,
      InternalAdminGrantHistoricalAccessMutationVariables
    >(INTERNAL_ADMIN_GRANT_HISTORICAL_ACCESS_MUTATION);

  const onClick = useCallback(() => {
    if (!distributionGroup) return;
    internalAdminGrantHistoricalAccessMutationAPI({
      variables: {
        organizationId: distributionGroup.organizationId,
        distributionGroupId: distributionGroup.id,
        userId,
      },
    });
  }, [
    distributionGroup,
    internalAdminGrantHistoricalAccessMutationAPI,
    userId,
  ]);

  const icon = useMemo(() => {
    if (loading) {
      return <Spinner size="sm" />;
    }
    return <ClockArrowPlusIcon fill={colors.blue} boxSize={5} />;
  }, [loading]);

  if (
    !distributionGroup ||
    distributionGroup.historicalAccessUserIdList.includes(userId)
  ) {
    return null;
  }

  return (
    <SyncoTooltip label="Click to grant Historical Access">
      <CircularIconButton
        aria-label="grant historical access"
        variant="ghost"
        onClick={onClick}
        icon={icon}
      />
    </SyncoTooltip>
  );
};

export default memo(InternalAdminGrantHistoricalAccessButton);
